export default [
  {
    path: "/system/userCenter",
    component: () => import(/* webpackChunkName: "UserCenter" */ "@/views/systemParent/UserCenter"),
    name: "system-user-center",
    meta: { keepAlive: false }
  },
  {
    path: "/system/systemMaintenance",
    component: () => import(/* webpackChunkName: "SystemMaintenance" */ "@/views/systemParent/SystemMaintenance"),
    name: "system-maintenance",
    meta: { keepAlive: false }
  }
]